import { get, put, remove, post } from './api-helper';

export const postCustomer = (data) => post('customers', data);

export const getCustomers = () => get('customers');

export const putCustomer = (id, params) => put(`customers/${id}`, params);

export const getAppointments = (params) => get(`appointments?aggregates=1&q=${params}`);
